export const sites = {
  Add_new_site: "Ajouter un nouveau site",
  Address: "Adresse",
  Address_1: "Adresse 1",
  Address_2: "Adresse 2",
  All_sites: "Tous les sites",
  Applicability: "Applicabilité",
  Basic_information: "Informations de base",
  City: "Ville",
  "Country_*": "Pays *",
  Create_assessment: "Créer une évaluation",
  Create_new_site: "Créer un nouveau site",
  edit: "Modifier",
  Edit_site_details: "Modifier les détails du site",
  upload_your_templates: "Télécharger vos modèles de site remplis",
  Here_you_can_manage_all_sites_in_your_organization: "Ici vous pouvez gérer tous les sites de votre organisation",
  "Name_*": "Nom *",
  Postcode: "Code postal",
  Release_to_drop_the_files_here: "Relâchez pour déposer les fichiers ici",
  "Relevant_standard_*": "Standard pertinent *",
  Save_site: "Enregistrer le site",
  "Scope_of_applicability_*": "Portée d'applicabilité *",
  "Site_coordinator_*": "Coordinateur de site *",
  siteCoordinator: "Coordinateur de site",
  siteName: "Nom du site",
  Standard_Body: "Organisme de normalisation",
  Standards: "Standards",
  State: "État/Province",
  Template: "Modèle",
  create_site_from_template: "Créer un site à partir d'un fichier modèle",
  You_can_upload_many_sites_in_the_same_file: "Vous pouvez télécharger plusieurs sites dans le même fichier",
} as const;
